import { t } from "i18next";


export class RoleTitle {
  id: number;
  roleType: string;
  singularTitle: string;
  pluralTitle: string;

  constructor(id: number, roleType: string, singularTitle?: string, pluralTitle?: string) {
    this.id = id;
    this.roleType = roleType;
    this.singularTitle = singularTitle ?? "";
    this.pluralTitle = pluralTitle ?? "";
  }

  static getRoleTitlesFromData(roleNrId: number, roleData: { [key: string]: any }) {
    let id: string = roleData.id ?? "";
    let singularTitle: string = "";
    let pluralTitle: string = "";
    if (id === "tenant") {
      singularTitle = t('main.tenant');
      pluralTitle = t('main.tenants');
    } else if (id === "resident") {
      singularTitle = t('main.resident');
      pluralTitle = t('main.residents');
    } else if (id === "landlord") {
      singularTitle = t('main.landlord');
      pluralTitle = t('main.landlords');
    } else if (id === "manager") {
      singularTitle = t('main.manager');
      pluralTitle = t('main.managers');
    } else {
      singularTitle = roleData.singular;
      pluralTitle = roleData.plural;
    }
    return new RoleTitle(roleNrId, id, singularTitle, pluralTitle);
  }
}
